import axios from '@/utils/miniAxios'
const api = {
    tasksDetail: '/api/tasks',
    brandDetail: '/api/brands',
    // /{taskId}/getTaskApplyByTaskId
    getApply: '/api/task/applys/',
    getAddress: '/api/merchant/addresses',
    uploadFile: '/commons/file/upload',
    taskApplyDetail: '/api/task/applys',
    userInfo: '/api/users',
    reduceRight: '/api/task/applys'
}

/**
 * accountInfo
 * @returns {Promise<any>}
 */
export function getInfo () {
    return new Promise((resolve, reject) => {
        axios.get(api.userInfo)
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * 查看权益信息
 * @returns {Promise<any>}
 */
export function getRightInfo (id) {
    return new Promise((resolve, reject) => {
        axios.get(api.reduceRight + '/' + id)
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * 消耗即刻任务权益码
 * @returns {Promise<any>}
 */
export function reduceRight (id) {
    return new Promise((resolve, reject) => {
        axios.put(api.reduceRight + '/' + id + '/reduceInviolableRights')
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * 上传文件
 * @param file {File} 文件 formData
 * @param onUploadProgress {Function} 上传进度
 * @return {Promise}
 */
export function fetchUpload (file, type) {
    const data = new FormData()
    data.append('file', file)
    return new Promise((resolve, reject) => {
        axios.post(`${api.uploadFile}?type=${type}`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then((response) => {
            resolve(response.data)
        }).catch((error) => {
            console.log('catch fetchUpload ', error)
            reject(error.msg || '未知错误')
        })
    })
}
/**
 * 查询任务详情
 * @returns {Promise<any>}
 */
export function fetchTaskById (id, params) {
    return new Promise((resolve, reject) => {
        axios.get(api.tasksDetail + '/' + id, { params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function getBrandId (id, params) {
    return new Promise((resolve, reject) => {
        axios.get(api.brandDetail + '/' + id, { params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

/**
 * 查询地址详情
 * @returns {Promise<any>}
 */
export function fetchAddressById (id) {
    return new Promise((resolve, reject) => {
        axios.get(api.getAddress + '/' + id)
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

/**
 * 查询任务报名详情
 * @returns {Promise<any>}
 */
export function fetchTaskApplyById (id) {
    return new Promise((resolve, reject) => {
        axios.get(api.getApply + '/' + id + '/getTaskApplyByTaskId')
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * 新增链接/图片
 * @returns {Promise<any>}
 */
export function addTaskLink (id, params) {
    return new Promise((resolve, reject) => {
        axios.post(`${api.tasksDetail}/${id}/applyImmediately`, { ...params })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * 修改链接/图片
 * @returns {Promise<any>}
 */
export function modifyTaskLink (id, params) {
    return new Promise((resolve, reject) => {
        axios.put(`${api.taskApplyDetail}/${id}/updateImmediately`, { ...params })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * 查询任务列表
 * @returns {Promise<any>}
 */
export function fetchTask (params) {
    return new Promise((resolve, reject) => {
        axios.get(api.taskList, { params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
